import React, { useContext, useEffect, useState } from "react";
import { FilterBar, Switch, useDebounce } from "@sscs/ui";
import { produce } from "immer";
import { isEqual } from "lodash";
import { filterUpdated, initFilter, selectFilter, selectFilteredByLink, } from "../../../store/vulnerabilitySlice";
import { CveFilter, VulnerabilitySeverityFilter, VulnerabilityTagFilter, } from "../../common";
import { ReportContext } from "../../context";
import { useReportDispatch, useReportSelector } from "../../hooks";
import { useLazyGetVulnerabilityCveListQuery } from "../../services/vulnerabilities.api";
import { isFilteredByLink } from "../../utils";
import ReferencesFilter from "./ReferencesFilter";
import styles from "./vulnerabilityFilter.module.scss";
const VulnerabilityFilter = () => {
    var _a;
    const { reportId } = useContext(ReportContext);
    const dispatch = useReportDispatch();
    const filter = useReportSelector(selectFilter);
    const [localCVE, setLocalCVE] = useState(filter.cve_number);
    const [fetchCveList, { data: cveList, isFetching: isCVEListFetching }] = useLazyGetVulnerabilityCveListQuery();
    const filteredByLink = useReportSelector(selectFilteredByLink);
    const handleFilterChange = (filter) => {
        dispatch(filterUpdated(filter));
    };
    useEffect(() => {
        setLocalCVE(filter.cve_number);
    }, [filter.cve_number]);
    useDebounce(localCVE, undefined, (value) => {
        /* Update debounced filter only when not set via redux action
         *
         * Updating when set via action will cause cve to be reset
         * and multiple vulnerabilities endpoint will be queried instead of specific item endpoint */
        if (filter.cve_number !== value) {
            handleFilterChange(produce(filter, (draft) => {
                {
                    draft.cve_number = value;
                }
            }));
        }
    });
    return (React.createElement(FilterBar, { filters: [
            {
                id: "references",
                row: 1,
                minWidth: "280px",
                control: (React.createElement(ReferencesFilter, { filter: filter, filteredByLink: filteredByLink, onFilterChange: handleFilterChange })),
            },
            {
                id: "cve",
                row: 2,
                minWidth: "280px",
                control: (React.createElement(CveFilter, { className: styles.autocomplete, value: localCVE, cveList: (_a = cveList === null || cveList === void 0 ? void 0 : cveList.cve_list) !== null && _a !== void 0 ? _a : [], loading: isCVEListFetching, onOpen: () => fetchCveList({ ui_id: reportId }), onChange: (value) => {
                        setLocalCVE(value);
                    }, "data-filtered-by-link": isFilteredByLink(filter, initFilter, "cve_number", filteredByLink) })),
            },
            {
                id: "tag",
                row: 2,
                width: "350px",
                control: (React.createElement(VulnerabilityTagFilter, { value: filter.exploit_type, onChange: (value) => handleFilterChange(produce(filter, (draft) => {
                        {
                            draft.exploit_type = value;
                        }
                    })), className: styles["tag-filter"], "data-filtered-by-link": !isEqual(filter.exploit_type.toSorted(), initFilter.exploit_type.toSorted()) && filteredByLink })),
            },
            {
                id: "severity",
                row: 2,
                width: "200px",
                control: (React.createElement(VulnerabilitySeverityFilter, { value: filter.cvss_score_severity, onChange: (value) => {
                        handleFilterChange(produce(filter, (draft) => {
                            {
                                draft.cvss_score_severity = value;
                            }
                        }));
                    }, className: styles["severity-filter"], "data-filtered-by-link": isFilteredByLink(filter, initFilter, "cvss_score_severity", filteredByLink) })),
            },
            {
                id: "triaged",
                row: 2,
                fit: true,
                control: (React.createElement(Switch, { title: "Filter vulnerabilities", label: "Hide triaged", checked: filter.hide_triaged, onChange: (event) => handleFilterChange({
                        ...filter,
                        hide_triaged: event.target.checked,
                    }) })),
            },
        ] }));
};
export default VulnerabilityFilter;
//# sourceMappingURL=VulnerabilityFilter.js.map